import { useTranslation } from 'react-i18next'
import { ToastContentProps } from 'react-toastify'

import InfoBox from '@/Atomic/Molecules/InfoBox'

interface FilterToastProps extends Partial<ToastContentProps> {
  variant: 'applied' | 'saved'
  onClearFilter?: () => void
}

export const FilterToast = ({
  variant,
  closeToast,
  onClearFilter,
}: FilterToastProps) => {
  const { t } = useTranslation()

  const handleClearFilter = () => {
    onClearFilter?.()
    closeToast?.()
  }

  const content = {
    applied: {
      className: 'filter-applied-toast',
      title: t('advancedSearch.filterApplied'),
      subtitle: t('advancedSearch.unsavedFilter'),
    },
    saved: {
      className: 'filter-saved-toast',
      title: t('advancedSearch.filterSaved'),
      subtitle: t('advancedSearch.filterHasBeenApplied'),
    },
  }[variant]

  return (
    <InfoBox
      type="success"
      className={content.className}
      onClose={() => closeToast?.()}
    >
      <div className="info-box-toast-text">{content.title}</div>
      <div className="info-box-toast-subtext">{content.subtitle}</div>
      <a
        onClick={handleClearFilter}
        className="text-decoration-underline"
        style={{
          fontSize: '14px',
          marginTop: '4px',
          cursor: 'pointer',
          color: 'inherit',
          display: 'inline-block',
        }}
      >
        {t('advancedSearch.clearFilter')}
      </a>
    </InfoBox>
  )
}
